/* Wellsons cart: keeps add-ons with the product they were added for, in the cart drawer AND on the cart page.
   Removing a vanity (or changing its quantity) also removes / scales every line added with it
   (lines whose _io_parent_order_group = the vanity's _io_order_group). Works for vanity-builder
   builds and for old Infinite Options bundles alike. Lines without add-ons are left alone. */
(function () {
  if (window.__wsCartGroups) return; window.__wsCartGroups = 1;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function sel(v) { return window.CSS && CSS.escape ? CSS.escape(v) : String(v).replace(/["\\]/g, '\\$&'); }
  function post(up) {
    return fetch(ROOT + 'cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: up })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); });
  }
  function scaled(kq, oldQ, qty) { return qty === 0 ? 0 : Math.max(1, Math.round(kq / (oldQ || 1) * qty)); }

  /* ---- cart drawer (.ws-cd) ---- */
  document.addEventListener('click', function (e) {
    var q = e.target && e.target.closest ? e.target.closest('.ws-cd [data-ws-qty]') : null; if (!q) return;
    if (q.getAttribute('data-ws-pass')) { q.removeAttribute('data-ws-pass'); return; }
    var li = q.closest('[data-key]'), d = q.closest('.ws-cd');
    if (!li || li.getAttribute('data-io-child') === 'true' || !d || !d.querySelector('[data-io-child="true"]')) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var key = li.getAttribute('data-key'), qty = Math.max(0, parseInt(q.getAttribute('data-ws-qty'), 10) || 0);
    var pass = function () { q.setAttribute('data-ws-pass', '1'); q.click(); }; // hand back to the drawer as normal
    fetch(ROOT + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
      var line = cart.items.filter(function (i) { return i.key === key; })[0];
      var grp = line && line.properties && line.properties._io_order_group;
      var kids = grp ? cart.items.filter(function (i) { return i.properties && i.properties._io_parent_order_group === grp; }) : [];
      if (!kids.length) { pass(); return; }
      var up = {}; up[key] = qty;
      kids.forEach(function (k) { up[k.key] = scaled(k.quantity, line.quantity, qty); });
      li.style.opacity = '.5';
      return post(up).then(function (res) {
        if (window.WSCart && WSCart.refresh) WSCart.refresh();
        document.dispatchEvent(new CustomEvent('ws:cart:changed', { detail: res.j }));
      });
    }).catch(function () { li.style.opacity = ''; pass(); });
  }, true);

  /* ---- cart page ([data-ws-main-cart]) ---- */
  function pageGroup(li) {
    var page = li && li.closest('[data-ws-main-cart]'); if (!page) return null;
    var grp = li.getAttribute('data-io-group'); if (!grp || li.getAttribute('data-io-child') === 'true') return null;
    var kids = page.querySelectorAll('[data-io-parent="' + sel(grp) + '"][data-key]');
    return kids.length ? { page: page, kids: kids } : null;
  }
  function pageChange(li, g, qty) {
    var oldQ = +li.getAttribute('data-qty') || 1, up = {};
    up[li.getAttribute('data-key')] = qty;
    Array.prototype.forEach.call(g.kids, function (k) { up[k.getAttribute('data-key')] = scaled(+k.getAttribute('data-qty') || 0, oldQ, qty); });
    var n = g.page.querySelector('[data-ws-notice]');
    li.classList.add('is-updating'); g.page.classList.add('is-busy');
    post(up).then(function (res) {
      if (n) {
        var t = li.getAttribute('data-title') || 'Item';
        n.classList.toggle('is-error', !res.ok); n.hidden = false;
        n.textContent = !res.ok ? (res.j.description || res.j.message || 'Sorry, that quantity is not available.')
          : qty === 0 ? 'Removed ' + t + ' and its vanity options.' : 'Updated ' + t + ' and its vanity options.';
      }
      if (window.WSCartPage && WSCartPage.refresh) WSCartPage.refresh();
      document.dispatchEvent(new CustomEvent('ws:cart:changed', { detail: res.j }));
    }).catch(function () { li.classList.remove('is-updating'); })
      .then(function () { g.page.classList.remove('is-busy'); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-ws-main-cart] [data-ws-step], [data-ws-main-cart] [data-ws-remove]') : null; if (!b) return;
    var li = b.closest('[data-key]'), g = pageGroup(li); if (!g) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var qty = b.hasAttribute('data-ws-remove') ? 0 : Math.max(0, (+li.getAttribute('data-qty') || 0) + (+b.getAttribute('data-ws-step') || 0));
    pageChange(li, g, qty);
  }, true);
  document.addEventListener('change', function (e) {
    var inp = e.target && e.target.closest ? e.target.closest('[data-ws-main-cart] [data-ws-qty-input]') : null; if (!inp) return;
    var li = inp.closest('[data-key]'), g = pageGroup(li); if (!g) return;
    var v = parseInt(inp.value, 10);
    if (isNaN(v) || v < 0 || v === +li.getAttribute('data-qty')) return; // let the page handle bad input / no change
    e.stopImmediatePropagation();
    pageChange(li, g, v);
  }, true);
})();
